export default __webpack_public_path__ + "static/media/trailerpack_horiz_blue_bkg.1aa85be8.png";